import { defineComponent, PropType } from "vue";
import StepOffers from "../../steps/b2c/StepOffers";
import StepUpload from "../../steps/b2c/StepUpload";
import StepForm from "../../steps/b2c/StepForm";
import StepInvoice from "../../steps/b2c/StepInvoice";
import StepVerify from "../../steps/b2c/StepVerify";
import Utils from "../../utils/Utils";
import StepInvoiceReco from "../../steps/b2c/StepInvoiceReco";
import { OfferJson, OrderJson } from "../../OrderForm";
import StepOfferDetails from "../../steps/b2c/StepOfferDetails";

export default defineComponent({
    components: {
        StepOffers,
        StepOfferDetails,
        StepUpload,
        StepInvoice,
        StepInvoiceReco,
        StepForm,
        StepVerify,
    },

    template: `
        <StepInvoice
            v-if="isStep('invoice')"
            :options="options"

            @next="onInvoiceNext"
            @noinvoice="setStep('noinvoice')"
        />

        <StepInvoiceReco
            v-if="isStep('invoice.recommend')"
            :options="options"
            :offer="options.offer"

            @offer:select="setStep('invoice.details', $event)"
            @invoice:change="setStep('invoice')"
            @more:click="setStep('offers.all')"
        />

        <StepOfferDetails
            v-if="isStep('invoice.details')"
            :offer="options.offer"
            :code="options.code"

            @offer:select="onOfferSelect"
            @more:click="setStep('offers.all')"
        />

        <StepVerify
            v-if="isStep('invoice.verify')"
            :options="options"

            @edit="setStep('invoice.form.invoice', options.offer)"
            @accept="setStep('invoice.form.consents', options.offer)"
            @back="setStep('offers.all')"
            @invoice:change="setStep('invoice')"
        />

        <StepForm
            v-if="isStep('invoice.form*')"
            :options="options"
            step_prefix="invoice.form."

            @back="setStep('invoice')"
            @verify="setStep('invoice.verify', options.offer)"
        />
    `,

    emits: [
        'noinvoice',
    ],

    props: {
        options: { type: Object as PropType<OrderJson>, required: true },
    },

    mounted() {
        this.step = this.options.terms && this.options.documents?.length ? 2 : 1
    },

    methods: {
        isStep(val: string) {
            return Utils.isStep(val);
        },

        setStep(step: string, offer?: OfferJson) {
            Utils.setStep(step, offer);
        },

        async onOfferSelect(offer: OfferJson) {
            if (this.options.complete && !this.options.verified) {
                Utils.setStep('invoice.verify', offer);
            } else {
                Utils.setStep('invoice.form.invoice', offer);
            }
        },
    },

    setup(props, ctx) {
        function onInvoiceNext() {
            if (props.options.sme) {
                if (props.options.complete) {
                    Utils.setStep('sme.verify');
                } else {
                    Utils.setStep('sme.niperror');
                }
            } else {
                Utils.setStep('invoice.recommend');
            }
        }

        return {
            onInvoiceNext,
        };
    },
});
